import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { createProductDefaultDataBinding } from "@/libs/commerce/ProductContent";

import { PRODUCT_STANDARD_DETAILS_CONTAINER_INPUTS } from "./StandardProductDetailsContainer.inputs.builder";

export const StandardProductDetailsContainerComponent: RegisteredComponent = {
  name: "StandardProductDetailsContainer",
  friendlyName: "Standard Product Details Container",
  component: dynamic(
    async () =>
      (await import("./StandardProductDetailsContainer"))
        .StandardProductDetailsContainer,
    { ssr: true }
  ),
  models: [getBuilderModelName("product")],
  defaults: {
    bindings: createProductDefaultDataBinding<
      typeof PRODUCT_STANDARD_DETAILS_CONTAINER_INPUTS
    >({
      bundlesConfig: "productBundlesConfig",
      categories: "productCategories",
      productCta: "productCta",
      currentVariantId: "productCurrentVariantId",
      currentVariantSku: "productCurrentVariantSku",
      description: "productDescription",
      dynamicGallery: "productDynamicGallery",
      galleryAssets: "productGalleryAssets",
      hasDiscountBadge: "productHasDiscountBadge",
      hasStrikethroughPrice: "productHasStrikethroughPrice",
      hideCta: "productHideCta",
      isBundle: "productIsBundle",
      isDynamicGalleryEnabled: "productIsDynamicGalleryEnabled",
      isMultiPackEnabled: "productIsMultiPackEnabled",
      isTrial: "productIsTrial",
      knowMoreUrl: "productKnowMoreUrl",
      multiPackDescription: "productMultiPackDescription",
      multiPackName: "productMultiPackName",
      multiPackProducts: "productMultiPackProducts",
      productName: "productName",
      sku: "productSku",
      trustpilot: "productTrustpilot",
      videoGallery: "productVideoGallery",
      configurableOptions: "productConfigurableOptions",
      nonTradeInSku: "productNonTradeInSku",
    }),
  },
  inputs: PRODUCT_STANDARD_DETAILS_CONTAINER_INPUTS,
};
